import { BaseService } from "./baseService";
import { PatientDocumentDto } from "../types/patientDocument";

class PatientDocumentService extends BaseService<PatientDocumentDto> {
  constructor() {
    super("/PatientDocument");
  }
}

export const patientDocumentService = new PatientDocumentService();
